<div class="modal-header">
    <div class="text-wrap">
        <p class="body2 black-color font-400">Filter by</p>
        <button type="button" class="btn btnThemeOutline blue me-2" (click)="filterReset()">
            Reset
        </button>
    </div>
    <button type="button" class="btn btnIcon" (click)="closeModal()">
        <img src="./assets/images/close.svg" class="btn-icon" alt="close"/>
    </button>
</div>

<form [formGroup]="filterForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-wrap">
                    <div class="form-row form-row mb-5">
                        <div class="input-group inputGroup">
                            <mat-form-field class="w-100 mat-input-group form-date-control" appearance="outline" id="dateRange">
                                <mat-label class="matLabel">Reg Date</mat-label>
                                <!-- <mat-select formControlName="entityTypeID">
                                    <mat-option [value]="item.id" *ngFor="let item of statusList">{{item.label}}</mat-option>
                                </mat-select> -->
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate (click)="picker.open()" formControlName="stDtGrEq" readonly placeholder="Start date">
                                    <input matEndDate  (click)="picker.open()" formControlName="enDtLsEq" readonly placeholder="End date">
                                </mat-date-range-input>
                                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row form-row mb-5" *ngIf="uiPrivileges?.displayRegStatusFilter">
                        <div class="input-group inputGroup">
                            <mat-form-field class="w-100 mat-input-group form-select-control" appearance="outline" id="statusIn">
                                <mat-label class="matLabel">Reg Status</mat-label>
                                <mat-select multiple formControlName="statusIn">
                                    <mat-option [value]="item.id" *ngFor="let item of contestStatusesData">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row form-row mb-5">
                        <div class="input-group inputGroup">
                            <mat-form-field class="w-100 mat-input-group form-select-control" appearance="outline" id="valStatus">
                                <mat-label class="matLabel">Validation Status</mat-label>
                                <mat-select multiple formControlName="valStatus">
                                    <mat-option [value]="item.id" *ngFor="let item of valStatusList">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row form-row" *ngIf="uiPrivileges?.displaylanguageFilter">
                        <div class="input-group inputGroup">
                            <mat-form-field class="w-100 mat-input-group form-select-control" appearance="outline" id="langIn">
                                <mat-label class="matLabel">Select Language</mat-label>
                                <mat-select multiple formControlName="langIn">
                                    <mat-option [value]="item.name" *ngFor="let item of langInList">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row form-row">
                        <div class="input-group inputGroup">
                            <mat-form-field class="w-100 mat-input-group form-select-control" appearance="outline" id="sourceIn">
                                <mat-label class="matLabel">Source</mat-label>
                                <mat-select multiple formControlName="sourceIn">
                                    <mat-option [value]="item.id" *ngFor="let item of contestSourcesList">{{item.name}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="w-100 d-flex justify-content-center">
            <button class="btn btnThemeOutline blue me-3" (click)="closeModal()">
                Cancel
            </button>
            <button type="button" class="btn btnTheme blue" (click)="onSubmit()">
                Apply
            </button>
        </div>
    </div>
</form>
